import React from 'react'

export default () => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 22 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      stroke="#454545"
      strokeWidth="2"
      fill="none"
      fillRule="evenodd"
      strokeLinejoin="round"
    >
      <path d="M1.072 1.087l6.25 6.068s1.344 1.208 1.344 2.8v5.668M20.944 1.087l-6.25 6.068s-1.344 1.208-1.344 2.8v5.668" />
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/icons/filterIcon.js